<template>
  <WithTopNav :leftText="game?.gameName" class="middlePage" fixed>
    <div class="p-4">
      <div class="text-15 flex-center-y gap-2">
        <span class="opacity-75">{{ categary.display || categary.name }}</span>
        <!-- <template v-if="roomName">
          <van-icon name="arrow" />
          <span class="opacity-75">{{ roomName }}</span> -->
          <template v-if="game?.gameName">
            <van-icon name="arrow" />
            <span>{{ game?.gameName }}</span>
          </template>
        <!-- </template> -->
      </div>

      <div class="mainBox">
        <van-image
          lazy-load
          class="banner"
          :src="game?.banner"
          @click="gotoGame(game, $router)"
        />
        <h3 class="text-18 font-[600] mt-3.5 mb-6">{{ game?.gameName }}</h3>
        <div class="primaryBtn" @click="gotoGame(game, $router)"> JOGUE </div>
      </div>

      <div>
        <h3 class="tit">Recomendados</h3>
        <GameLists :list="recList" class="py-4 pt-6 gap-2.5" itemClass="w-[77px] h-[105px]"/>
      </div>
    </div>
  </WithTopNav>
</template>

<script setup lang="ts">
  import GameLists from '@a/components/GameLists/index.vue'
  import { gotoGame } from '@/utils'
  import WithTopNav from '@/layouts/withTopNav.vue'

  const { game, categary, recList } = history.state
</script>

<style scoped lang="scss">
  .middlePage {
    @apply bgs-[url('@a/assets/images/bg_game.png'),0_159px];

    .tit {
      @apply text-[15px] font-[600] leading-[22px] my-2 bgs-[url('@a/assets/images/title_bg.png'),0_center,contain] pl-8;
    }

    .mainBox {
      @apply flex flex-col items-center pt-[26px] pb-[16px];

      .banner{
        @apply w-[153px] h-[208px] rounded-[10px] overflow-hidden shadow-[0_4px_10px_#13640B40];
      }
    }

    .item{
      @apply w-[77px] h-[105px] rounded-[5px] overflow-hidden relative;
    }

    .gName {
      @apply absolute bottom-0 left-0 right-0 font-[600] leading-[20px] text-center;
    }
  }
</style>
